import React, { Component } from 'react';
import { Query } from 'react-apollo';

import '../../style/PublicationHistory.scss';
import queries from '../../queries';
import { backEndUri } from '../../config';
import { timeAgo } from '../../toast';
import { t, tn, dateLocale } from '../../i18n';
import { subscribeSaveState } from '../../saveStatus';

// Pastille « Publiée il y a … » + fenêtre d'historique des publications (lecture seule, téléchargement par version).
class PublicationHistory extends Component {

  state = { open: false };

  componentDidMount() {
    // Après chaque enregistrement réussi, on recontrôle s'il y a des modifications non publiées.
    this.unsubscribeSave = subscribeSaveState(({ status }) => {
      if (status === 'saved' && this.refetchState) {
        clearTimeout(this.refetchTimer);
        this.refetchTimer = setTimeout(() => this.refetchState(), 1200);
      }
    });
  }

  componentDidUpdate(_, prevState) {
    if (this.state.open && !prevState.open) window.addEventListener('keydown', this.onKey);
    if (!this.state.open && prevState.open) window.removeEventListener('keydown', this.onKey);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKey);
    if (this.unsubscribeSave) this.unsubscribeSave();
    clearTimeout(this.refetchTimer);
  }

  onKey = (e) => { if (e.key === 'Escape') this.setState({ open: false }); };

  renderModal() {
    const { projectId } = this.props;
    return (
      <div className='tsk-ui-modal-overlay' onMouseDown={() => this.setState({ open: false })}>
        <div className='tsk-ui-modal-surface tsk-pubhistory' role='dialog' aria-label={t('ui.hist.title')} onMouseDown={(e) => e.stopPropagation()}>
          <h3 className='tsk-ui-modal__title'>{t('ui.hist.title')}</h3>
          <Query query={queries.projects.publicationHistory} variables={{ id: projectId }} fetchPolicy='network-only'>
            {({ loading, error, data }) => {
              if (loading) return <p className='tsk-pubhistory__empty'>{t('ui.common.loading')}</p>;
              if (error) return <p className='tsk-pubhistory__empty'>{t('ui.hist.error', { message: error.message })}</p>;
              const history = [...(data.project.publication_history || [])].sort((a, b) => b.version - a.version);
              const installs = data.project.device_installs || [];
              if (history.length === 0) {
                return <p className='tsk-pubhistory__empty'>{t('ui.hist.never')}</p>;
              }
              const latest = history[0].version;
              return (
                <ul className='tsk-pubhistory__list'>
                  {history.map((h) => {
                    const onThis = installs.filter((i) => i.version === h.version).length;
                    return (
                      <li key={h.version} className='tsk-pubhistory__item'>
                        <span className='tsk-pubhistory__version'>v{h.version}</span>
                        <span className='tsk-pubhistory__info'>
                          <strong>{new Date(h.publication_date).toLocaleString(dateLocale, { dateStyle: 'medium', timeStyle: 'short' })}</strong>
                          <small>
                            {timeAgo(h.publication_date)}
                            {onThis > 0 ? tn('ui.hist.on_version', onThis) : ''}
                          </small>
                        </span>
                        {h.version === latest && <span className='tsk-badge tsk-badge--ok'>{t('ui.hist.current')}</span>}
                        <a className='tsk-pubhistory__download' href={`${backEndUri}/project/${projectId}/download/${h.version}`}>
                          {t('ui.hist.download')}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              );
            }}
          </Query>
          <div className='tsk-ui-modal__actions'>
            <button type='button' className='tsk-button' onClick={() => this.setState({ open: false })}>{t('ui.common.close')}</button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { projectId, latestVersion } = this.props;
    return (
      <Query query={queries.projects.publishState} variables={{ id: projectId }} fetchPolicy='cache-and-network' pollInterval={45000}>
        {({ data, refetch }) => {
          this.refetchState = refetch;
          const state = data && data.project;
          const latest = (state && state.latest_version) || latestVersion;
          const dirty = !!(state && state.has_unpublished_changes);
          let text = t('ui.hist.pill_never');
          if (latest) text = dirty ? t('ui.hist.pill_dirty') : t('ui.hist.pill_ok', { when: timeAgo(latest.publication_date) });
          return (
            <>
              <button
                type='button'
                className={`tsk-publish-status tsk-publish-status--button${latest && !dirty ? '' : ' is-never'}`}
                title={dirty ? t('ui.hist.pill_dirty_title', { when: timeAgo(latest.publication_date) }) : t('ui.hist.pill_title')}
                onClick={() => this.setState({ open: true })}
              >
                <span className='tsk-publish-status__dot' />
                {text}
              </button>
              {this.state.open && this.renderModal()}
            </>
          );
        }}
      </Query>
    );
  }
}

export default PublicationHistory;
